/**
 * These are raw URL templates. The main api library will include these.
 * Unless you know what you are doing, you should not include/require
 * these directly. You probably want to require() the lib/api/api
 * library and use Api.urls, which are functions you can pass params to.
 */
export default({
    // Get version info for the API
    ide_version: '/version',
    // All grants in the system
    grants: '/v5/grants',

    // The collection of all accounts
    accounts: '/v5/accounts',
    // A single account
    account: '/v5/accounts/{{id}}',
    // Permissions that THIS account has on {{account}}
    permissions: '/v5/accounts/{{id}}/permissions',
    // Account correpsonding to api user
    account_me: '/v5/accounts/me',
    // Roles endpoint
    roles: '/v5/roles',
    // Roles available to assign to Accounts
    accounts_roles: '/v5/roles?filter[type]=eq:account_role',
    // What rights other accounts have on me?
    account_grants: '/v5/grants?filter[target]={{id}}',
    // what rights do I have on other account?
    account_capabilities: '/v5/grants?filter[grantee]={{id}}',
    // A single role assigned to a single account
    account_role: '/v5/accounts/{{id}}/roles/{{account_role_id}}',
    // The metrics for an account
    account_metrics: '/v5/accounts/{{id}}/metrics',
    // The counts for an account
    account_counts: '/v5/accounts/{{id}}/counts',
    // Reset url
    account_password_change: '/v5/accounts/{{id}}/password',
    // Reset email
    account_email_change: '/v5/accounts/{{id}}/email',
    // Account Details Change
    account_details_change: '/v5/accounts/{{id}}',
    // Account Usage
    account_usage: '/v5/accounts/{{id}}/usage',


    // Auth
    auth: '/v5/auth',
    // Get a new Auth token with a Refresh Token
    auth_token: '/v5/auth/token',
    // Sign up for a new account
    auth_signup: '/v5/signup',
    // Verify a signup token
    auth_verify_signup: '/v5/verify',
    // Request a password change token
    auth_request_password_reset: '/v5/auth/password_reset',
    // Reset a password using a token
    auth_reset_password: '/v5/auth/password_reset/{{token}}',
    // Get totp verification
    auth_totp: '/v5/auth/totp',
    // TOTP code verification
    auth_verify_totp: '/v5/auth/totp_verification',
    // Recovery keys for mfa
    auth_recovery_keys: '/v5/auth/mfa_recovery',

    // Blinkup
    enrol: '/v5/enroll',

    // dev_device_poll: '/v2/setup_tokens/developer',
    // Polling new endpoint ui side
    dev_device_poll: '/v5/enroll/{{token}}',
    // Invitations to the requesting account
    invitations: '/v5/invitations',
    // Invitations to a single Account
    account_invitations: '/v5/invitations?filter[target.id]=eq:{{id}}',

    // Feedback in the UI (Top Nav)
    feedback: '/ui/user_feedback',

    // Invites urls
    invites: '/v5/invites',
    account_invites: '/v5/invites?filter[target.id]=neq:{{id}}',

    // Account login keys
    login_keys: '/v5/accounts/me/login_keys',
    login_key: '/v5/accounts/me/login_keys/{{id}}',

    // Account server profiles
    devicegroup_profiles: '/v5/accounts/{{id}}/devicegroup_profiles',

    // The collection of all products
    products: '/v5/products',
    // A single product
    product: '/v5/products/{{id}}',
    // Product statistics
    product_counts: '/v5/products/{{id}}/counts',

    // The collection of all device groups
    device_groups: '/v5/devicegroups',
    // A single device group
    device_group: '/v5/devicegroups/{{id}}',
    // DUTs (devices under test) collection for a devicegroup
    device_group_duts: '/ui/devicegroups/{{id}}/duts',
    // Search for a Device Group
    device_group_search: '/ui/devicegroups/search?q={{term}}',
    // Device group counts
    device_group_counts: '/v5/devicegroups/{{id}}/counts',
    // Device group history
    device_group_history: '/v5/devicegroups/{{id}}/history',
    // Device group devices
    device_group_devices: '/v5/devicegroups/{{id}}/relationships/devices',
    device_group_restart: '/v5/devicegroups/{{id}}/restart',
    device_group_conditional_restart: '/v5/devicegroups/{{id}}/conditional_restart',
    device_group_min_deployment: '/v5/devicegroups/{{id}}/relationships/min_supported_deployment',
    device_group_draft: '/ui/v2/draft/{{devicegroup_id}}',
    device_group_connections: '/ui/devicegroups/{{devicegroup_id}}/connections',
    device_group_bandwidth: '/ui/devicegroups/{{devicegroup_id}}/bandwidth',

    // Deployments
    deployments: '/v5/deployments',
    // A single deployment
    deployment: '/v5/deployments/{{id}}',
    // Deployments no code - used to POST a deployment with nocode param
    deployments_nocode: '/v5/deployments?nocode={{nocode}}',
    // Deployment with id - used to PATCH a deployment with nocode param
    deployment_nocode: '/v5/deployments/{{id}}?nocode={{nocode}}',

    // v5 devices collection
    devices: '/v5/devices',
    devices_search: '/ui/devices/search?q={{term}}',
    devices_for_account: '/v5/devices?filter[owner.id]={{account_id}}',
    // A single device
    device: '/v5/devices/{{id}}',
    // Device Bandwidth
    device_bandwidth: '/ui/devices/{{id}}/bandwidth',
    // Restart a device
    device_restart: '/v5/devices/{{id}}/restart',
    device_conditional_restart: '/v5/devices/{{id}}/conditional_restart',

    syntax_check: '/v5/utilities/syntax_check',

    // All webhooks, takes filter[devicegroup.id]
    webhooks: '/v5/webhooks',
    // Webhooks for a single devicegroup
    devicegroup_webhooks: '/v5/webhooks?filter[devicegroup.id]={{devicegroup_id}}',
    // A single webhook
    webhook: '/v5/webhooks/{{id}}',

    // Open a logstream for an account
    logstream: '/v5/logstream',
    // See historical logs for a given device id
    logs: '/v5/devices/{{device_id}}/logs',

    // See history about a given device
    history: '/v5/devices/{{device_id}}/history',

    v3_models: '/ide/v3/models',

    // Cloud config
    cloud_config: '/ui/config',

    // ImpCentral settings
    settings: '/ui/settings',

    // Temporary Cellcount UI Endpoint
    cellcount: '/ui/cellcount',

    // Current product development device counts
    devcounts: '/ui/products/{{product_id}}/devcounts',

    // Notifications for billing and payments
    notifications: '/ui/notifications',

    // Billing Endpoints
    billing_source: '/ui/billing/source',

    billing: '/ui/billing',
    invoices: '/ui/billing/invoices/',
    payment: '/ui/billing/payment',
    billing_history: '/ui/billing/pending',
});
